import { useParams } from "react-router";
import { FormattedMessage as FM } from "react-intl";

import Bird from "./img/Bird.png";
import imgMeal from "assets/apps/logo-melhous-yellow.png";
import MelhousDiving from "./img/MelhousDiving.png";
import Footer from "pages/Footer";
import Header from "../../layout/Header";
import "../../style.css";

const FinishPage = ({ booking }) => {
  const { id } = useParams();
  const fallbackUrl = "https://www.melhous.com/";
  const finalUrl = booking?.link_melhous || fallbackUrl;

  if (!id) {
    return <div>Configura ambiente o el folio no existe</div>;
  }

  return (
    <div className="flex flex-col min-h-screen">
      <div className="relative z-50">
        <Header />
      </div>

      <div className="flex-1 flex flex-col md:grid md:grid-cols-[1fr_35%] w-full overflow-hidden">
        <div className="flex flex-col justify-center items-center px-6 py-10 z-20 md:pl-18 md:pr-40 space-y-7">
          <h1 className="text-4xl md:text-6xl font-playfair text-[#375E3D] text-center md:text-left">
            <FM id="hotel.folio.guest.finish" />
          </h1>

          <div className="text-lg md:text-xl font-light text-center">
            <FM id="hotel.folio.guest.finish_description" />
          </div>

          <div className="text-base md:text-2xl font-medium text-center font-playfair">
            <FM id="hotel.folio.guest.finish_tra" />
          </div>

          <button
            type="button"
            onClick={() => window.open(finalUrl, "_blank")}
            className="relative flex w-full h-[140px] md:h-[200px] rounded-[30px] overflow-hidden bg-black cursor-pointer"
          >
            <div className="flex flex-col justify-center items-start px-6 w-[60%] z-10 mb-7 md:mt-0 mt-4">
              <img
                src={imgMeal}
                className="h-12 md:h-20 object-contain mb-2"
                alt="logo-melhous"
              />
              <span className="text-white text-[10px] md:text-base text-left ">
                <FM id="app.webcheckin.melhos.description" />
                <span
                  onClick={(e) => {
                    e.stopPropagation();
                    window.open(finalUrl, "_blank");
                  }}
                  className="text-yellow-400 underline ml-1 hover:text-yellow-300 transition-colors"
                >
                  <FM id="app.webcheckin.melhos.click" />
                </span>
              </span>
            </div>

            <div className="absolute right-0 top-0 w-[50%] h-full">
              <img
                src={MelhousDiving}
                alt=""
                className="h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-l from-transparent via-black/40 to-black" />
            </div>
          </button>

          <div className="text-lg md:text-xl font-light text-center">
            <FM id="app.webcheckin.melhos.use_app" />
          </div>
        </div>

        <div className="relative h-[250px] md:h-auto overflow-visible bg-gradient-to-l from-emerald-100 via-[#A9C49E] to-[#88AB79]">
          <img
            src={Bird}
            alt=""
            className="absolute top-0 left-1/2 -translate-x-[45%] -translate-y-[25%] min-w-[140%] h-auto z-30 md:top-[40%] md:left-0 md:-translate-y-[45%] md:-translate-x-[25%] md:min-w-[200%] md:h-[140%] object-cover"
          />
        </div>
      </div>

      <Footer style="bg-neutral-800 w-full" />
    </div>
  );
};

export default FinishPage;
